import {camelCaseToSentenceCase} from './getCamelCaseToTitleCase'
export function getColumnLabel(explicitKeyLabelMapping, columnKey) {
  const labelMapping = explicitKeyLabelMapping.find((mapping) => mapping.key === columnKey)
  return labelMapping ? labelMapping.label : camelCaseToSentenceCase(columnKey)
}
